// import { useState } from 'react';
// import { useGetLmsFullContentById } from '../../assets/nodeApi/getApi/getAdminApi';
// import { useParams } from 'react-router-dom';
// import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
// import { SkeletonCom } from '../../shared/utils/SkeletonCom';
// import CustomDivider from '../../shared/utils/CustomDivider';
// import {
//     Box,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     Typography,
//     Grid2
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { getFileUrl, Grid_Gap } from '../../shared/constants';
// import PdfFlipbook from '../../shared/components/proteacher/PdfViewer';
// import VideoPlayer from '../../shared/components/proteacher/VideoPlayer';
// import { useGetLmsBasicDetail, useGetLmsTopic } from '../../assets/api/useAdminApi';

// const AudioPlayer = ({ src }) => {
//     return (
//         <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2, maxWidth: "100%", my: 2 }}>
//             <Typography variant="subtitle1" mb={1}>
//                 Audio Preview:
//             </Typography>
//             {src ? (
//                 <audio
//                     src={src}
//                     controls
//                     preload="metadata"
//                     style={{ width: "100%" }}
//                     onError={(e) => console.log("Audio error:", e)}
//                 />
//             ) : (
//                 <Typography variant="body2" color="error">
//                     Audio not available
//                 </Typography>
//             )}
//         </Box>
//     );
// };


// const LmsFullContentDetail = () => {
//     const { id } = useParams();
//     const { data: lmsFullContent, isLoading } = useGetLmsFullContentById(id);
//     const { data: lmsBasicDetail, isLoading: isLmsBasicDetailLoading } = useGetLmsBasicDetail(id)
//     const { data: lsmTopics, isLoading: isLmsTopicsLoading } = useGetLmsTopic(id)
//     console.log(lmsBasicDetail, "detail")
//     const [expandedTopic, setExpandedTopic] = useState(null);
//     const [expandedSubtopic, setExpandedSubtopic] = useState(null);
//     const [expandedParagraph, setExpandedParagraph] = useState(null);

//     const handleTopicChange = (topicId) => {
//         setExpandedTopic(expandedTopic === topicId ? null : topicId);
//     };

//     const handleSubtopicChange = (subtopicId) => {
//         setExpandedSubtopic(expandedSubtopic === subtopicId ? null : subtopicId);
//     };

//     const handleParagraphChange = (paragraphId) => {
//         setExpandedParagraph(expandedParagraph === paragraphId ? null : paragraphId);
//     };
//     const courseDetail = {
//         "Course Type": lmsBasicDetail?.mapping?.course_type,
//         Grade: lmsBasicDetail?.mapping?.grade?.name,
//         Board: lmsBasicDetail?.mapping?.board?.name,
//         Language: lmsBasicDetail?.mapping?.language?.name,
//         Publication: lmsBasicDetail?.mapping?.publication?.name,
//         Level: lmsBasicDetail?.mapping?.level?.name

//     }

//     return (
//         <NormalContainerWithHeader headerText={lmsFullContent?.courseName}>
//             {isLoading && (
//                 <Box sx={{ padding: "1rem" }}>
//                     {[...Array(5)].map((_, index) => (
//                         <Box key={index}>
//                             <SkeletonCom height={50} style={{ borderRadius: "5px" }} />
//                             <CustomDivider size={"1rem"} />
//                         </Box>
//                     ))}
//                 </Box>
//             )}

//             {!isLoading &&

//                 <>
//                     <Grid2 container spacing={Grid_Gap}>

//                         {Object.entries(courseDetail).map(([key, value], index) => (
//                             <Grid2 children size={6}>
//                                 <Typography variant="body2" fontWeight={600}>
//                                     {key} : {value}
//                                 </Typography>
//                             </Grid2>

//                         ))}

//                     </Grid2>
//                     <CustomDivider />
//                     {

//                         lmsFullContent?.topics?.map((topic, topicIndex) => (
//                             <Box key={topic.id} sx={{ mb: 3 }}>
//                                 <Accordion
//                                     expanded={expandedTopic === topic.id}
//                                     onChange={() => handleTopicChange(topic.id)}
//                                     sx={styles.accordionTopic}
//                                 >
//                                     <AccordionSummary expandIcon={<ExpandMoreIcon />} >
//                                         <Typography variant="body1" fontWeight={600}>Topic {topicIndex + 1} : {topic.name}</Typography>
//                                     </AccordionSummary>

//                                     <AccordionDetails>
//                                         {topic.subtopics?.map((subtopic, subTopicIndex) => (
//                                             <Accordion
//                                                 key={subtopic.id}
//                                                 expanded={expandedSubtopic === subtopic.id}
//                                                 onChange={() => handleSubtopicChange(subtopic.id)}
//                                                 sx={styles.accordionSubtopic}
//                                             >
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ border: "1px solid #4169E1", borderRadius: 1, py: 0 }}>
//                                                     <Typography variant="body2" fontWeight={600}>Subtopic {subTopicIndex + 1} : {subtopic.name}</Typography>
//                                                 </AccordionSummary>

//                                                 <CustomDivider size={"0.5rem"} />
//                                                 <AccordionDetails>

//                                                     {expandedSubtopic === subtopic.id && <Typography variant="body2" fontWeight={600} mb={2}> {subtopic.description}</Typography>}
//                                                     <CustomDivider size={"0.5rem"} />
//                                                     <Typography>File</Typography>
//                                                     {subtopic.files?.map((lessonDetail, index) => (


//                                                         <Box>
//                                                             <CustomDivider size={"0.5rem"} />

//                                                             {lessonDetail?.file_type === 'video' ? (
//                                                                 <VideoPlayer url={lessonDetail?.file_path} play={false} height={350} />
//                                                             ) : lessonDetail?.file_type === "image" ? <Box
//                                                                 component={"img"}
//                                                                 src={getFileUrl(lessonDetail?.file_path)}
//                                                                 sx={{ width: "70%" }}

//                                                             /> : (
//                                                                 <PdfFlipbook uri={getFileUrl(lessonDetail?.file_path)} />

//                                                             )}

//                                                             <CustomDivider size={10} />
//                                                             <Typography variant="h6" textAlign={"start"}>{lessonDetail?.title}</Typography>
//                                                             <CustomDivider size={5} />

//                                                             {lessonDetail?.file_type === 'video' && (
//                                                                 <>
//                                                                     <Typography variant="body2" textAlign={"start"}>
//                                                                         Duration: {lessonDetail?.duration} Min
//                                                                     </Typography>

//                                                                     <CustomDivider size={5} /> </>
//                                                             )}

//                                                             <CustomDivider size={20} />

//                                                             <Typography variant="body2" textAlign={"start"} >
//                                                                 {lessonDetail?.description}
//                                                             </Typography>
//                                                         </Box>

//                                                     ))}
//                                                     <CustomDivider size={"0.5rem"} />
//                                                     {subtopic.paragraphs?.map((paragraph, index) => (
//                                                         <Accordion
//                                                             key={paragraph.id}
//                                                             expanded={expandedParagraph === paragraph.id}
//                                                             onChange={() => handleParagraphChange(paragraph.id)}
//                                                             sx={styles.accordionParagraph}
//                                                         >
//                                                             <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ border: "1px solid #4169E1", borderRadius: 1, py: 0 }}>
//                                                                 <Typography variant="body2" fontWeight={500}>
//                                                                     Paragraph {index + 1}
//                                                                 </Typography>
//                                                             </AccordionSummary>

//                                                             <AccordionDetails>
//                                                                 {/* Paragraph content */}
//                                                                 <CustomDivider size={"0.5rem"} />
//                                                                 <Typography
//                                                                     variant="body2"
//                                                                     dangerouslySetInnerHTML={{ __html: paragraph.description }}
//                                                                 />
//                                                                 {paragraph?.audios?.map((a, aIndex) => (
//                                                                     <Box key={a.id} sx={styles.questionBox}>
//                                                                         <AudioPlayer src={a.audio_url} />
//                                                                     </Box>
//                                                                 ))}

//                                                                 {/* Questions & answers */}
//                                                                 <Box sx={styles.qaContainer}>
//                                                                     {paragraph.questions?.map((q, qIndex) => (
//                                                                         <Box key={q.id} sx={styles.questionBox}>
//                                                                             <Typography variant="subtitle2" sx={styles.questionText}>
//                                                                                 Q {qIndex + 1}: {q.question_text}
//                                                                             </Typography>
//                                                                             {q.answers?.map((a, idx) => {
//                                                                                 const letter = String.fromCharCode(65 + idx); // 65 is 'A' in ASCII
//                                                                                 return (
//                                                                                     <Typography key={a.id} variant="body2" sx={styles.answerText}>
//                                                                                         {letter}. {a.answer_text} {a.is_correct && "(Correct)"}
//                                                                                     </Typography>
//                                                                                 );
//                                                                             })}

//                                                                         </Box>
//                                                                     ))}
//                                                                 </Box>

//                                                             </AccordionDetails>
//                                                         </Accordion>
//                                                     ))}

//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         ))}
//                                     </AccordionDetails>
//                                 </Accordion>
//                             </Box>
//                         ))}



//                 </>
//             }
//         </NormalContainerWithHeader>
//     );
// };

// // ===== STYLES =====
// const styles = {
//     accordionTopic: {
//         border: "1px solid #4169E1",
//         borderRadius: 5,
//         boxShadow: 'none',
//         mb: 1
//     },
//     accordionSubtopic: {
//         // border: "1px solid #4169E1",
//         backgroundColor: '#F7FAFF',
//         borderRadius: 3,
//         boxShadow: 'none',
//         mb: 1
//     },
//     accordionParagraph: {
//         // border: "1px solid #4169E1",
//         backgroundColor: '#ffffff',
//         borderRadius: 2,
//         boxShadow: 'none',
//         mb: 1
//     },
//     qaContainer: {
//         mt: 1,
//         pl: 2,
//     },
//     questionBox: {
//         mb: 1,
//     },
//     questionText: {
//         fontWeight: 600,
//         color: '#333',
//     },
//     answerText: {
//         ml: 2,
//         color: '#555',
//     }
// };

// export default LmsFullContentDetail;






import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import {
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Grid2,
    IconButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getFileUrl, Grid_Gap } from '../../shared/constants';
import PdfFlipbook from '../../shared/components/proteacher/PdfViewer';
import VideoPlayer from '../../shared/components/proteacher/VideoPlayer';
import { useGetLmsBasicDetail, useGetLmsSubtopic, useGetLmsSubtopicDetail, useGetLmsTopic } from '../../assets/api/useAdminApi';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';


const AudioPlayer = ({ src }) => {
    return (
        <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2, maxWidth: "100%", my: 2 }}>
            <Typography variant="subtitle1" mb={1}>
                Audio Preview:
            </Typography>
            {src ? (
                <audio
                    src={src}
                    controls
                    preload="metadata"
                    style={{ width: "100%" }}
                    onError={(e) => console.log("Audio error:", e)}
                />
            ) : (
                <Typography variant="body2" color="error">
                    Audio not available
                </Typography>
            )}
        </Box>
    );
};


const LmsFullContentDetail = () => {
    const navigate = useNavigate()
    const { id } = useParams();
    const { data: lmsBasicDetail, isLoading: isLmsBasicDetailLoading } = useGetLmsBasicDetail(id)
    const [expandedTopic, setExpandedTopic] = useState(null);
    const [expandedSubtopic, setExpandedSubtopic] = useState(null);
    const [expandedParagraph, setExpandedParagraph] = useState(null);

    // ---------- TOPIC PAGINATION ----------
    const {
        data: topicData,
        fetchNextPage: fetchNextTopicPage,
        hasNextPage: hasNextTopicPage,
        isFetchingNextPage: isFetchingNextTopicPage,
        isLoading: islmsTopicLoading,
    } = useGetLmsTopic(id);

    const loadMoreTopicRef = useRef();

    useEffect(() => {
        const current = loadMoreTopicRef.current;

        if (!current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasNextTopicPage) {
                    fetchNextTopicPage();
                }
            },
            { rootMargin: "100px" }
        );

        observer.observe(current);

        return () => {
            observer.unobserve(current);
        };
    }, [hasNextTopicPage, topicData]);



    // ---------- SUBTOPIC PAGINATION (BASED ON SELECTED TOPIC) ----------
    const {
        data: subtopicData,
        fetchNextPage: fetchNextSubtopicPage,
        hasNextPage: hasNextSubtopicPage,
        isFetchingNextPage: isFetchingNextSubtopicPage,
        isLoading: islmsSubTopicLoading,
    } = useGetLmsSubtopic(expandedTopic);

    const loadMoreSubTopicRef = useRef();

    useEffect(() => {
        const current = loadMoreSubTopicRef.current;

        if (!current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasNextSubtopicPage) {
                    fetchNextSubtopicPage();
                }
            },
            { rootMargin: "100px" }
        );

        observer.observe(current);

        return () => {
            observer.unobserve(current);
        };
    }, [hasNextSubtopicPage, subtopicData]);



    const handleTopicChange = (topicId) => {
        setExpandedTopic(expandedTopic === topicId ? null : topicId);
        setExpandedSubtopic(null)
        setExpandedParagraph(null)
    };

    const { data: subTopicDetail, isLoading: subTopicLoading } = useGetLmsSubtopicDetail(expandedSubtopic)

    const handleSubtopicChange = (subtopicId) => {
        setExpandedSubtopic(expandedSubtopic === subtopicId ? null : subtopicId);
        setExpandedParagraph(null)

    };

    const handleParagraphChange = (paragraphId) => {
        setExpandedParagraph(expandedParagraph === paragraphId ? null : paragraphId);
    };
    const courseDetail = {
        "Course Type": lmsBasicDetail?.mapping?.course_type,
        Grade: lmsBasicDetail?.mapping?.grade?.name,
        Board: lmsBasicDetail?.mapping?.board?.name,
        Language: lmsBasicDetail?.mapping?.language?.name,
        Publication: lmsBasicDetail?.mapping?.publication?.name,
        Level: lmsBasicDetail?.mapping?.level?.name

    }

    return (
        <NormalContainerWithHeader headerText={lmsBasicDetail?.courseName}>
            {isLmsBasicDetailLoading && (
                <Box sx={{ padding: "1rem" }}>
                    {[...Array(5)].map((_, index) => (
                        <Box key={index}>
                            <SkeletonCom height={50} style={{ borderRadius: "5px" }} />
                            <CustomDivider size={"1rem"} />
                        </Box>
                    ))}
                </Box>
            )}



            <>

                {
                    !isLmsBasicDetailLoading &&
                    <Grid2 container spacing={Grid_Gap}>

                        {Object.entries(courseDetail).map(([key, value], index) => (
                            <Grid2 children size={6}>
                                <Typography variant="body2" fontWeight={600}>
                                    {key} : {value}
                                </Typography>
                            </Grid2>

                        ))}

                    </Grid2>
                }

                <CustomDivider />
                {/* {
                    islmsSubTopicLoading &&
                    <Typography>Topic is Loading .....</Typography>
                } */}
                {
                    !islmsTopicLoading &&
                    <>
                        {topicData?.pages.map((page, topicPageIndex) =>
                            page.topics.map((topic, topicIndex) => (
                                <Box key={topic.id} sx={{ mb: 3 }}>
                                    <Accordion
                                        expanded={expandedTopic === topic.id}
                                        onChange={() => handleTopicChange(topic.id)}
                                        sx={styles.accordionTopic}
                                    >
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography variant="body1" fontWeight={600}>
                                                Topic {topicPageIndex * 10 + (topicIndex + 1)} : {topic.name}
                                            </Typography>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            {/* ----------- LOAD SUBTOPICS ONLY FOR OPENED TOPIC ----------- */}
                                            {expandedTopic === topic.id && (
                                                <>
                                                    {
                                                        islmsSubTopicLoading && <Typography>subtopic is loading...... </Typography>
                                                    }

                                                    {
                                                        !islmsSubTopicLoading && <>
                                                            {subtopicData?.pages.map((page, pageIndex) =>
                                                                page.subtopics.map((subtopic, index) => (
                                                                    <Accordion
                                                                        key={subtopic.id}
                                                                        sx={styles.accordionSubtopic}
                                                                        expanded={expandedSubtopic === subtopic.id}
                                                                        onChange={() => handleSubtopicChange(subtopic.id)}
                                                                    >
                                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                            <Typography variant="body2" fontWeight={600}>
                                                                                Subtopic {pageIndex * 10 + (index + 1)} : {subtopic.name}
                                                                            </Typography>
                                                                            <IconButton onClick={() => {
                                                                                navigate(`/admin/addlmssubtopic/${topic?.id}/${subtopic.id}`)
                                                                            }}>
                                                                                <EditIcon fontSize='10' />
                                                                            </IconButton>
                                                                        </AccordionSummary>


                                                                        <CustomDivider size={"0.5rem"} />
                                                                        <AccordionDetails>
                                                                            {expandedSubtopic === subtopic.id && (
                                                                                <>

                                                                                    {subTopicLoading ? (
                                                                                        <Typography variant='body1' color='#000'>Loading subtopic detail...</Typography>
                                                                                    ) : (
                                                                                        <>
                                                                                            <Typography variant="body2" fontWeight={600} mb={2}>
                                                                                                {subTopicDetail?.subtopic?.description}
                                                                                            </Typography>

                                                                                            <CustomDivider size={"0.5rem"} />

                                                                                            {/* -------- FILES SECTION -------- */}
                                                                                            <Typography fontWeight={600}>Files</Typography>

                                                                                            {subTopicDetail?.subtopic?.lms_subtopic_files?.map(
                                                                                                (lessonDetail, index) => (
                                                                                                    <Box key={lessonDetail.id}>
                                                                                                        <CustomDivider size={"0.5rem"} />

                                                                                                        {lessonDetail?.file_type === "video" ? (
                                                                                                            <VideoPlayer
                                                                                                                url={lessonDetail?.file_path}
                                                                                                                play={false}
                                                                                                                height={350}
                                                                                                            />
                                                                                                        ) : lessonDetail?.file_type === "image" ? (
                                                                                                            <Box
                                                                                                                component={"img"}
                                                                                                                src={getFileUrl(lessonDetail?.file_path)}
                                                                                                                sx={{ width: "70%" }}
                                                                                                            />
                                                                                                        ) : (
                                                                                                            <PdfFlipbook
                                                                                                                uri={getFileUrl(lessonDetail?.file_path)}
                                                                                                            />
                                                                                                        )}

                                                                                                        <CustomDivider size={10} />

                                                                                                        <Typography variant="h6">
                                                                                                            {lessonDetail?.file_name}
                                                                                                        </Typography>

                                                                                                        <Typography variant="body2">
                                                                                                            {lessonDetail?.description}
                                                                                                        </Typography>
                                                                                                    </Box>
                                                                                                )
                                                                                            )}

                                                                                            <CustomDivider size={"1rem"} />

                                                                                            {/* -------- PARAGRAPHS SECTION -------- */}
                                                                                            {subTopicDetail?.subtopic?.lms_paragraphs?.map(
                                                                                                (paragraph, index) => (
                                                                                                    <Accordion
                                                                                                        key={paragraph.id}
                                                                                                        expanded={expandedParagraph === paragraph.id}
                                                                                                        onChange={() =>
                                                                                                            handleParagraphChange(paragraph.id)
                                                                                                        }
                                                                                                        sx={styles.accordionParagraph}
                                                                                                    >
                                                                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                                                            <Typography variant="body2" fontWeight={500}>
                                                                                                                Paragraph {index + 1}
                                                                                                            </Typography>
                                                                                                        </AccordionSummary>

                                                                                                        <AccordionDetails>
                                                                                                            <Typography
                                                                                                                variant="body2"
                                                                                                                dangerouslySetInnerHTML={{
                                                                                                                    __html: paragraph.description,
                                                                                                                }}
                                                                                                            />

                                                                                                            {paragraph?.lms_paragraph_audios?.map((a) => (
                                                                                                                <AudioPlayer
                                                                                                                    key={a.id}
                                                                                                                    src={a.audio_url}
                                                                                                                />
                                                                                                            ))}
                                                                                                        </AccordionDetails>
                                                                                                    </Accordion>
                                                                                                )
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </AccordionDetails>
                                                                    </Accordion>
                                                                ))
                                                            )}



                                                            <>

                                                                <IconButton
                                                                    onClick={() => { navigate(`/admin/addlmssubtopic/${topic?.id}`) }}
                                                                    sx={{ display: "flex", justifyContent: "center" }}
                                                                >
                                                                    <AddIcon /> <Typography>Add Subtopic</Typography>
                                                                </IconButton>
                                                            </>


                                                            {isFetchingNextSubtopicPage && <p>Loading more subtopics...</p>}

                                                            <div ref={loadMoreSubTopicRef}
                                                                style={{ height: "20px", marginTop: "10px" }}
                                                            ></div>
                                                        </>
                                                    }


                                                </>
                                            )}


                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            ))
                        )}
                        <>

                            <IconButton
                                onClick={() => { navigate(`/admin/addlms/${id}`) }}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <AddIcon /> <Typography>Add Topic</Typography>
                            </IconButton>
                        </>

                        {isFetchingNextTopicPage && <p>Loading more topics...</p>}

                        <div
                            ref={loadMoreTopicRef}
                            style={{ height: "20px", marginTop: "10px" }}
                        />
                    </>
                }



            </>

        </NormalContainerWithHeader>
    );
};

// ===== STYLES =====
const styles = {
    accordionTopic: {
        border: "1px solid #4169E1",
        borderRadius: 5,
        boxShadow: 'none',
        mb: 1
    },
    accordionSubtopic: {
        // border: "1px solid #4169E1",
        backgroundColor: '#F7FAFF',
        borderRadius: 3,
        boxShadow: 'none',
        mb: 1
    },
    accordionParagraph: {
        // border: "1px solid #4169E1",
        backgroundColor: '#ffffff',
        borderRadius: 2,
        boxShadow: 'none',
        mb: 1
    },
    qaContainer: {
        mt: 1,
        pl: 2,
    },
    questionBox: {
        mb: 1,
    },
    questionText: {
        fontWeight: 600,
        color: '#333',
    },
    answerText: {
        ml: 2,
        color: '#555',
    }
};

export default LmsFullContentDetail;






































